<template>
  <div class="home">
    115
  </div>
</template>

<script>


export default {
  name: "Home"
};
</script>
